import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-edu-bped',
  templateUrl: './edu-bped.component.html',
  styleUrls: ['./edu-bped.component.scss']
})
export class EduBpedComponent implements OnInit {
  education:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.education=this.facultyService.getEducation();
  }
}
